export const InputType = {
  SPOTIFY: 'SPOTIFY',
  SPOTIFY_ARTISTS: 'SPOTIFY_ARTISTS',
  CSV: 'CSV',
  SP2: 'SP2',
  NEW_VERSION: 'NEW_VERSION',
};
